// "New survey" as a page, on the survey page's section layout: where the
// steps start from, the details, and every step open for editing, created
// together (create-survey-page.tsx).

import { createFileRoute } from "@tanstack/react-router";
import { CreateSurveyPage } from "@/features/surveys/create-survey-page";

export const Route = createFileRoute("/w/$workspaceId/surveys/new")({
    component: NewSurveyPage,
});

function NewSurveyPage() {
    const { workspaceId } = Route.useParams();
    return <CreateSurveyPage workspaceId={workspaceId} />;
}
